export default __webpack_public_path__ + "static/media/template-name-img.2a62e993.png";